import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login.vue' // 登录页面
import Layout from '@/components/Layout.vue' //  带top菜单的布局
Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/', // 登录页面
      component: Login
    },
    {
      path: '/login', // 登录页面
      component: Login
    },
    {
      path: '/dev', // 页面开发
      component: () => import('@/views/dev/index.vue')
    },
    {
      name: '消息中心',
      path: '/msgs/center',
      role_name: ['超级管理员', '管理员', '甲方'],
      component: Layout,
      children: [
        {
          path: '',
          name: '消息列表', // 子路由的 name
          component: () => import('@/views/admin/msgs/index.vue')
        }
      ]
    },
    {
      name: '用户管理',
      role_name: ['超级管理员', '管理员'],
      path: '/users',
      redirect: '/users/list',
      component: Layout,
      children: [
        {
          path: 'list',
          name: '用户列表',
          role_name: ['超级管理员', '管理员'],
          component: () => import('@/views/admin/users/list.vue')
        },
        {
          path: 'work',
          name: '账号列表',
          role_name: ['超级管理员', '管理员'],
          component: () => import('@/views/admin/users/work.vue')
        },
        {
          path: 'account_log',
          name: '余额日志',
          role_name: ['超级管理员', '管理员'],
          component: () => import('@/views/admin/users/account_log.vue')
        },
        {
          path: 'online_log',
          name: '上线记录',
          role_name: ['超级管理员', '管理员'],
          component: () => import('@/views/admin/users/online_log.vue')
        },
        {
          path: 'withdraw',
          name: '提现列表',
          role_name: ['超级管理员', '管理员'],
          component: () => import('@/views/admin/finance/list.vue')
        }
      ]
    },

    {
      name: '甲方管理',
      role_name: ['超级管理员'],
      path: '/employer',
      redirect: '/employer/list',
      component: Layout,
      children: [
        {
          path: 'list',
          name: '甲方列表',
          role_name: ['超级管理员', '管理员'],
          component: () => import('@/views/admin/employer/list.vue')
        },
        {
          path: 'account_log',
          name: '甲方余额日志',
          role_name: ['超级管理员', '管理员'],
          component: () => import('@/views/admin/employer/account_log.vue')
        }
      ]
    },

    {
      name: '项目管理',
      role_name: ['超级管理员', '管理员'],
      path: '/project',
      redirect: '/project/list',
      component: Layout,
      children: [
        {
          path: 'list',
          name: '项目列表',
          role_name: ['超级管理员', '管理员'],
          component: () => import('@/views/admin/project/list.vue')
        }
      ]
    },
    {
      name: '财务管理',
      role_name: ['超级管理员'],
      path: '/finance',
      redirect: '/finance/withdraw',
      component: Layout,
      children: [
        {
          path: 'withdraw',
          name: '提现列表',
          role_name: ['超级管理员', '管理员'],
          component: () => import('@/views/admin/finance/list.vue')
        },
        {
          path: 'statistics',
          name: '统计数据',
          role_name: ['超级管理员'],
          component: () => import('@/views/admin/finance/statistics.vue')
        }
      ]
    },

    {
      name: '系统管理',
      role_name: ['超级管理员'],
      path: '/sys',
      redirect: '/sys/seting',
      component: Layout,
      children: [
        {
          path: 'seting',
          name: '基础设置',
          role_name: ['超级管理员'],
          component: () => import('@/views/admin/sys/seting.vue')
        },
        {
          path: 'cloud',
          name: '云中客',
          role_name: ['超级管理员'],
          component: () => import('@/views/admin/sys/cloud.vue')
        }
      ]
    },

    // 甲方相关页面

    {
      name: '项目管理',
      role_name: ['甲方'],
      path: '/e',
      redirect: '/e/list',
      component: Layout,
      children: [
        {
          path: 'list',
          name: '项目列表',
          role_name: ['甲方'],
          component: () => import('@/views/employer/project.vue')
        },
        {
          path: 'statistics',
          name: '扣款统计',
          role_name: ['甲方'],
          component: () => import('@/views/employer/deduction_statistics.vue')
        }
      ]
    },
    {
      name: '余额明细',
      role_name: ['甲方'],
      path: '/employer_account',
      redirect: '/employer_account/list',
      component: Layout,
      children: [
        {
          path: 'list',
          name: '余额明细',
          role_name: ['甲方'],
          component: () => import('@/views/employer/balance_list.vue')
        }
      ]
    },
    {
      name: '管理员管理',
      role_name: ['超级管理员'],
      path: '/admins',
      redirect: '/admins/list',
      component: Layout,
      children: [
        {
          path: 'list',
          name: '管理员列表',
          role_name: ['超级管理员'],
          component: () => import('@/views/admin/admins/list.vue')
        }
      ]
    },

    {
      path: '*', // 默认路由，匹配所有未定义的路由
      redirect: '/' // 重定向到公共页面
    }
  ]
})
